import React, { Component, Fragment } from 'react';
import ScrollLock from 'react-scrolllock';

import Header from '../NewProfile/Header';
import SideBarContent from '../SideBar/SideBarContent';
import Button from '../../artzu-ui/src/Button';
import via1 from '../../images/via1.jpg';
import via2 from '../../images/via2.jpg';

class RulesComponent extends Component {
  render() {
    const { id, history, status, email, operatingCity } = this.props;
    return (
      <div className="intro container new-course">
        {/introapp/.test(window.location.href) ? null : (
          <Header
            persistentTitle
            title="Rules"
            back
            onClick={() => {
              history.goBack();
            }}
          />
        )}
        <div className="new-course__body__footer--mobile">
          <div className="new-course__body__buttons">
            {/introapp/.test(window.location.href) ? (
              <a href={`/introapp/${Number(id) - 1}`}>
                <Button
                  color="#414141"
                  label="Previous"
                  size="xl"
                  padding="0"
                />
              </a>
            ) : (
              <Button
                color="#414141"
                label="Previous"
                size="xl"
                padding="0"
                onClick={() => history.push(`/intro/${Number(id) - 1}`)}
              />
            )}
            {/introapp/.test(window.location.href) ? (
              <a href="/dashboard">
                <Button primary label="Dashboard" size="xl" padding="0" />
              </a>
            ) : (
              <Button
                primary
                label="Dashboard"
                size="xl"
                padding="0"
                onClick={() => history.push('/dashboard')}
              />
            )}
          </div>
        </div>
        <ScrollLock>
          <div className="intro__content new-course__container">
            <div className="intro__sidebar new-course__sidebar">
              <SideBarContent status={status} signedIn={email} />
            </div>
            <div
              className="new-course__body"
              style={
                /introapp/.test(window.location.href)
                  ? { marginTop: '0' }
                  : null
              }>
              <div className="intro__content--container">
                <div className="intro__content__title">Be on time</div>
                <div className="intro__content__para">
                  When renting, your booking has a start and end time.
                  Please bring back the car by the end time of your booking
                  so that you are not charged any late fees and that the
                  driver after you can start on time.
                </div>
                <div className="intro__content__para">
                  Before the end time of your booking, if the car is still
                  available you will be asked if you’d like to extend for
                  another 4 hours. Otherwise, you will be reminded to bring
                  the car back.
                </div>
                <br />
                <div className="intro__content__title">
                  Fill up gas tank
                </div>
                <div className="intro__content__para">
                  When you pick up the car, expect that there will be a
                  full tank of gas. Please return the car with a full tank
                  before dropping it off.
                </div>
                {operatingCity === 'new_york' ? (
                  <div className="intro__content__para">
                    Autzu GO vehicles take Regular 87 gas.
                  </div>
                ) : (
                  <div className="intro__content__para">
                    Autzu PRO and PLUS can take Regular 87 gas, no need for
                    premium.
                  </div>
                )}
                <br />
                {operatingCity === 'new_york' ? (
                  <div className="intro__content__title">
                    Use the right plate in Via
                  </div>
                ) : (
                  <div className="intro__content__title">
                    Use the right plate in Uber
                  </div>
                )}
                {operatingCity === 'new_york' ? (
                  <div className="intro__content__para">
                    Before you start driving, you will need to go online in
                    the Via Driver App with the correct license plate of
                    the car you've been assigned.
                  </div>
                ) : (
                  <div className="intro__content__para">
                    Before you start driving, you will need to go online in
                    the Uber Driver App with the correct license plate of
                    the car you've been assigned.
                  </div>
                )}
                {operatingCity === 'new_york' ? null : (
                  <div className="intro__content__para">
                    In the Uber Driver App, tap your profile photo.
                  </div>
                )}
                {operatingCity === 'new_york' ? null : (
                  <div className="intro__content__para">
                    Go to Account > Vehicles then search for the vehicle
                    you've been assigned. Make sure to tap on the license
                    plate you want to use. DO NOT PRESS THE ADD VEHICLE
                    BUTTON.
                  </div>
                )}
                {operatingCity === 'new_york' ? null : (
                  <div className="intro__content__para">
                    Go back to the main page, and go online!
                  </div>
                )}
                {operatingCity === 'new_york' ? null : (
                  <div className="intro__content__para">
                    Remember to GO OFFLINE at the end of your booking,
                    otherwise you may block another driver from using the
                    plate and you will be fined a fee.{' '}
                  </div>
                )}
                {operatingCity === 'new_york' ? null : (
                  <div className="intro__content__video">
                    <iframe
                      width="100%"
                      height="100%"
                      src={`https://www.youtube.com/embed/GbD5NzM0FRE`}
                      frameBorder="0"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                      title="autzu"
                    />
                  </div>
                )}

                {operatingCity === 'new_york' ? (
                  <div className="via-img-row">
                    <img
                      id="via-img-column"
                      src={via1}
                      className="intro__content__img"
                    />
                    <img
                      id="via-img-column"
                      src={via2}
                      className="intro__content__img"
                    />
                  </div>
                ) : null}
                <br />
                <div className="intro__content__title">
                  What if I run into an issue with my car/booking?
                </div>
                <div className="intro__content__para">
                  1. Check the Help tab for information
                </div>
                <div className="intro__content__para">
                  2. Call our support to get help on your issue
                </div>
                <div className="intro__content__para">
                  3. If we are unable to swap you out to another vehicle,
                  you can file an Incident Report on your booking.
                </div>
                <br />
                {operatingCity === 'new_york' ? null : (
                  <div className="intro__content__video">
                    <iframe
                      width="100%"
                      height="100%"
                      src={`https://www.youtube.com/embed/9GLXhFL_0vs?rel=0`}
                      frameBorder="0"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                      title="autzu"
                    />
                  </div>
                )}
                <br />
                <br />
                <br />
              </div>
              <div className="new-course__body__footer--desktop intro__content__footer--desktop">
                <div className="new-course__body__buttons intro__content__footer--buttons">
                  <Button
                    color="#414141"
                    label="Previous"
                    size="xl"
                    onClick={() =>
                      history.push(`/intro/${Number(id) - 1}`)
                    }
                  />
                  <Button
                    primary
                    label="Dashboard"
                    size="xl"
                    onClick={() => history.push('/dashboard')}
                  />
                </div>
              </div>
            </div>
          </div>
        </ScrollLock>
      </div>
    );
  }
}

export default RulesComponent;



// WEBPACK FOOTER //
// ./src/components/Intro/RulesComponent.js